import LearningStreamReaderNode from './types/learning-stream-reader';
import LearningStreamWriterNode from './types/learning-stream-writer';

export const learningStreamNodes = {
  learningStreamReader: LearningStreamReaderNode,
  learningStreamWriter: LearningStreamWriterNode,
};
